export const poll = (pollTest: () => boolean, timeout: number, callback: () => void) => {
    const maxLoops = timeout / 100

    let totalLoops = 0
    let intervalId = setInterval(() => {
        if (!pollTest()) {
            totalLoops++

            if (totalLoops >= maxLoops) {
                clearInterval(intervalId)
            }

            return
        }

        callback()

        clearInterval(intervalId)
    }, 100)
}
